import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    title: 'Scripts Anti-Mecánico™',
    desc: 'Las frases exactas para pedir diagnóstico, bajar presupuestos y no pagar de más nunca más.',
    value: '$9.000'
  }, {
    title: 'Checklist Pre-Viaje Blindado™',
    desc: 'La revisión de 7 minutos que evita el 80% de las sorpresas en ruta. Con 3 versiones.',
    value: '$8.000'
  }, {
    title: 'Guía Express de Tablero y Testigos™',
    desc: 'Qué significa cada luz, qué tan urgente es y qué hacer en los primeros 60 segundos.',
    value: '$9.000'
  }, {
    title: 'Planilla Maestra de Gastos del Auto™',
    desc: 'Registrá todo, detectá fugas de dinero y sabé exactamente cuánto te cuesta tu auto.',
    value: '$8.000'
  }, {
    title: 'Auto Impecable en 20 Minutos™',
    desc: 'El protocolo para dejar tu auto impecable sin lavadero y con menos de $5.000 de insumos.',
    value: '$7.000'
  }];
  return <section className="py-24 relative" aria-label="Bonos estratégicos incluidos" data-id="element-13">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-yellow/5 blur-[150px] pointer-events-none" aria-hidden="true" data-id="element-14"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-15">
        <FadeIn data-id="element-16">
          <div className="text-center mb-16" data-id="element-17">
            <h2 className="text-4xl md:text-6xl font-bold mb-4 text-white" data-id="element-18">
              🎁 5 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-cyan text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-19">
              SIEMPRE INCLUIDOS
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-20">
          {bonuses.map((bono, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-21">
              <div className="bg-surface p-6 rounded-2xl border border-white/5 flex flex-col md:flex-row md:items-center justify-between gap-4 hover:border-yellow/30 transition-colors" data-id="element-22">
                <div className="flex items-start gap-4" data-id="element-23">
                  <span className="text-2xl" data-id="element-24">🎁</span>
                  <div data-id="element-25">
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-26">
                      Bono {i + 1}: {bono.title}
                    </h3>
                    <p className="text-gray-400 text-sm" data-id="element-27">{bono.desc}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 md:flex-col md:items-end md:gap-1 shrink-0" data-id="element-28">
                  <span className="text-gray-400 line-through text-sm" data-id="element-29">
                    Valor: {bono.value}
                  </span>
                  <span className="bg-yellow text-background font-bold px-3 py-1 rounded-md text-sm uppercase tracking-wide" data-id="element-30">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-31">
          <div className="text-center p-8 rounded-2xl bg-gradient-to-r from-surface to-surfaceLight border border-yellow/20" data-id="element-32">
            <p className="text-xl md:text-2xl font-medium" data-id="element-33">
              Valor total de los bonos:{' '}
              <span className="line-through text-gray-400" data-id="element-34">$41.000</span>{' '}
              <span className="text-yellow font-bold" data-id="element-35">
                → GRATIS con tu Mega Pack
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}